import React, { useState, useContext, useEffect } from 'react';
import Avatar from '@mui/material/Avatar';
import { UserContext } from '../contexts/UserContext';
import Box from '@mui/material/Box';
import SnackbarContext from '../contexts/SnackbarContext';
import { Typography, styled, ButtonBase, Card, CardActionArea, CardContent, Switch } from '@mui/material';
import { ShoppingCartProductsContext } from '../contexts/ShoppingCartProductsContext';
// import MyOrders from "../components/MyOrders"
import { useNavigate } from 'react-router-dom';
/* Icons */
import EditIcon from '@mui/icons-material/Edit';
import Receipt from '@mui/icons-material/Receipt';
import Pets from '@mui/icons-material/Pets';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import NotificationsIcon from '@mui/icons-material/Notifications';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import LogoutIcon from '@mui/icons-material/Logout';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { layoutCardRadius } from '../theme/colors';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const Profile = () => {
  const { currentUser, setCurrentUser } = useContext(UserContext);
  const { openSnackbar } = useContext(SnackbarContext);
  const { setTotalQuantity } = useContext(ShoppingCartProductsContext);
  const { setTotalAmount } = useContext(ShoppingCartProductsContext);
  const { setShoppingCartProducts } = useContext(ShoppingCartProductsContext);
  const navigate = useNavigate();
  const [notificationsEnabled, setNotificationsEnabled] = useState(true);

  useEffect(() => {
    document.title = 'Perfil - TudoPets.app';
  }, []);

  /* Toggle */
  useEffect(() => {
    document.title = 'Perfil - TudoPets.app';

    // Carregar preferência salva
    const savedNotificationSetting = localStorage.getItem('tp_notifications_enabled');
    if (savedNotificationSetting !== null) {
      setNotificationsEnabled(JSON.parse(savedNotificationSetting));
    }
  }, []);

  useEffect(() => {
    // Salvar quando mudar
    localStorage.setItem('tp_notifications_enabled', JSON.stringify(notificationsEnabled));
  }, [notificationsEnabled]);

  const handleLogout = () => {
    clearLocalStorage();
    openSnackbar('Logout efetuado com sucesso!');
  }

  const clearLocalStorage = () => {
    localStorage.removeItem('payment_method');
    localStorage.removeItem('shoppingProvider');
    localStorage.removeItem('shoppingProviderID');
    localStorage.removeItem('current_user');
    localStorage.setItem("shoppingCartProducts", '[]');
    localStorage.setItem("totalAmount", '0');
    localStorage.setItem("totalQuantity", '0');
    setTotalAmount(0);
    setTotalQuantity(0);
    setShoppingCartProducts([]);

    setCurrentUser(null); // when set, ProtectedRoute will redirect to login
  }

  const handleImageChange = (event) => {
    const file = event.target.files[0];
  };

  const handleAvatarClick = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.onchange = handleImageChange;
    input.click();
  };

  if (!currentUser) {
    return null;
  }

  const format1 = {
    display: 'flex',
    padding: '24px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 2,
    flex: '1 0 0',
    borderRadius: layoutCardRadius,
    bgcolor: 'surface.card'
  }

  const format2 = {
    display: 'flex',
    p: 2,
    justifyContent: 'center',
    alignItems: 'center',
    gap: 2,
    borderRadius: '50%',
    height: '48px',
    width: '48px',
    color: 'white',
    bgcolor: '#E97837'
  }

  const format3 = {
    display: 'flex',
    p: 0,
    alignItems: 'center',
    gap: 2,
    alignSelf: 'stretch',
    borderRadius: '50%',
    height: '48px',
    width: '48px',
    color: 'text.secondary',
    bgcolor: 'surface.card',
    width: '100%'
  }

  const style2 = {
    fontFamily: 'Nunito',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    color: '#546E7A'
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
      {/* Título */}
      <Typography variant="pageTitle">Perfil</Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, alignSelf: 'stretch' }}>

        {/* Foto e Editor */}
        <Box sx={{ display: 'inline-block', position: 'relative' }}>
          {/* Foto */}
          <Avatar
            alt={`${currentUser.name ? currentUser.name : currentUser.email}`}
            src="/static/images/avatar/2.jpg"
            sx={{ width: 120, height: 120 }}
          />

          {/* Botão para Mudar Img */}
          <ButtonBase
            onClick={handleAvatarClick}
            variant="outlined"
            component="label"
            sx={{ width: '32px', height: '32px', borderRadius: '50%', bgcolor: 'secondary.dark', color: 'white', display: 'flex', position: 'absolute', bottom: 0, right: 1, p: 1 }}>
            <EditIcon sx={{ width: '16px', height: '16px' }} />
          </ButtonBase>
        </Box>

        {/* Cliente / PS */}
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
          <Typography variant="storeName" sx={{ lineHeight: '20.8px' }}>
            {currentUser.name ? currentUser.name : currentUser.email}
          </Typography>
          <Typography sx={{ fontFamily: 'Nunito', fontWeight: 400, fontSize: '16px', lineHeight: '24px', color: '#546E7A' }}>
            {currentUser.email}
          </Typography>
        </Box>

        {/* Pedidos e Pets */}
        <Box sx={{ display: 'flex', alignItems: 'stretch', gap: 1, alignSelf: 'stretch' }}>
          {/* Pedidos*/}
          <Card sx={{ flex: 1, display: 'flex' }}>
            <CardActionArea sx={{ flex: 1, height: '100%', display: 'flex' }} onClick={() => navigate('/orders')}>
              <CardContent sx={{ ...format1, height: '100%', width: '100%' }}>
                <Box sx={{ ...format2 }}>
                  <Receipt />
                </Box>
                <Typography variant="storeName" sx={{ lineHeight: '20px' }}>Histórico de Pedidos</Typography>
              </CardContent>
            </CardActionArea>
          </Card>

          {/* Pets */}
          <Card sx={{ flex: 1, display: 'flex' }}>
            <CardActionArea sx={{ flex: 1, height: '100%', display: 'flex' }} onClick={() => navigate('/mypets')}>
              <CardContent sx={{ ...format1, height: '100%', width: '100%' }}>
                <Box sx={{ ...format2 }}>
                  <Pets />
                </Box>
                <Typography variant="storeName" sx={{ lineHeight: '20px' }}>Meus pets</Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Box>

        {/* Preferências */}
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', alignSelf: 'stretch', borderRadius: layoutCardRadius, bgcolor: 'surface.card' }}>
          <Box sx={{ width: '100%', borderBottom: '1px solid', borderBottomColor: 'border.subtle' }}>
            <CardActionArea data-no-shadow="true" sx={{ borderTopLeftRadius: layoutCardRadius, borderTopRightRadius: layoutCardRadius }} onClick={() => navigate('/profile/edit')}>
              <CardContent sx={{ padding: '24px', '&:last-child': { paddingBottom: '24px' } }}>
                <Box sx={{ ...format3 }}>
                  <ManageAccountsIcon sx={{ color: '#E97837' }} />
                  <Typography sx={{ width: '100%', textAlign: 'left', ...style2 }}>Editar perfil</Typography>
                  <KeyboardArrowRightIcon />
                </Box>
              </CardContent >
            </CardActionArea>
          </Box>
          <Box sx={{ width: '100%', borderBottom: '1px solid', borderBottomColor: 'border.subtle' }}>
            <CardActionArea data-no-shadow="true" onClick={() => navigate('/addresses', { state: { returnTo: '/profile' } })}>
              <CardContent sx={{ padding: '24px', '&:last-child': { paddingBottom: '24px' } }}>
                <Box sx={{ ...format3 }}>
                  <LocationOnIcon sx={{ color: '#E97837' }} />
                  <Typography sx={{ width: '100%', textAlign: 'left', ...style2 }}>Endereços</Typography>
                  <KeyboardArrowRightIcon />
                </Box>
              </CardContent >
            </CardActionArea>
          </Box>
          <Box sx={{ width: '100%', borderBottom: '1px solid', borderBottomColor: 'border.subtle' }}>
            <CardActionArea data-no-shadow="true">
              <CardContent sx={{ padding: '24px', '&:last-child': { paddingBottom: '24px' } }}>
                <Box sx={{ ...format3 }}>
                  <AccountBalanceWalletIcon sx={{ color: '#E97837' }} />
                  <Typography sx={{ width: '100%', textAlign: 'left', ...style2 }}>Carteira</Typography>
                  <KeyboardArrowRightIcon />
                </Box>
              </CardContent>
            </CardActionArea>
          </Box>
          <Box sx={{ width: '100%', borderBottomLeftRadius: layoutCardRadius, borderBottomRightRadius: layoutCardRadius, bgcolor: 'surface.card', boxShadow: '0px 1.5px 0px rgba(0,0,0,0.30)', overflow: 'visible' }}>
            <CardActionArea data-no-shadow="true" sx={{ borderBottomLeftRadius: layoutCardRadius, borderBottomRightRadius: layoutCardRadius }}>
              <CardContent sx={{ padding: '24px', '&:last-child': { paddingBottom: '24px' } }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', ...format3 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <NotificationsIcon sx={{ color: '#E97837' }} />
                    <Typography sx={{ ...style2 }}>
                      Notificações
                    </Typography>
                  </Box>
                  <Switch
                    checked={notificationsEnabled}
                    onChange={(e) => setNotificationsEnabled(e.target.checked)}
                    color="warning"
                  />
                </Box>
              </CardContent>
            </CardActionArea>
          </Box>

        </Box>
        <Card sx={{ width: '100%', borderBottom: '1px solid', borderBottomColor: 'border.subtle' }}>
          <CardActionArea>
            <CardContent sx={{ padding: '24px', '&:last-child': { paddingBottom: '24px' } }}>
              <Box sx={{ ...format3 }}>
                <ContactSupportIcon sx={{ color: '#E97837' }} />
                <Typography sx={{ width: '100%', textAlign: 'left', ...style2 }}>Suporte</Typography>
                <KeyboardArrowRightIcon />
              </Box>
            </CardContent>
          </CardActionArea>
        </Card>
        <Card sx={{ width: '100%', borderBottom: '1px solid', borderBottomColor: 'border.subtle' }}>
          <CardActionArea onClick={() => handleLogout()}>
            <CardContent sx={{ padding: '24px', '&:last-child': { paddingBottom: '24px' } }}>
              <Box sx={{ ...format3 }}>
                <LogoutIcon sx={{ color: '#E97837' }} />
                <Typography sx={{ ...style2 }}>Log out</Typography>
              </Box>
            </CardContent>
          </CardActionArea>
        </Card>
      </Box>
    </Box >
  );
};

export default Profile;
